export default __webpack_public_path__ + "static/media/item-rating-grey.0114ddd4.svg";